import type { Point2d } from "@logic/lib/2d"

import { findScrollPositionState } from "~/containers/LegacyDesigner/state/scroll"

import type { TransactionOperation } from "."

export const changePan: TransactionOperation<Point2d> = (
  { get, set },
  change,
) => {
  const panState = findScrollPositionState(`Studio`)
  const pan = get(panState)
  const newPan = {
    x: pan.x + change.x,
    y: pan.y + change.y,
  }
  set(panState, newPan)
}
